import { useState, useEffect } from 'react';
import S from './CheckBoxStyles';

type Props = {
  label: string;
  state?: boolean;
  disabled?: boolean;
  name?: string;
  onChange: any;
};

function CheckBox({
  label,
  disabled,
  name,
  state,
  onChange,
}: Props): JSX.Element {
  const [checkedState, toggleCheckedState] = useState(state);
  const handleClick = (): void => {
    if (!disabled) {
      toggleCheckedState(!checkedState);
      onChange(name, !checkedState);
    }
  };

  useEffect(() => {
    toggleCheckedState(state);
  }, [state]);

  return (
    <S.ItemWrapper onClick={handleClick}>
      <input type="checkbox" name={name} checked={checkedState} onChange={() => {}} />
      <label htmlFor={name} className={`${disabled ? 'disabled' : ''}`}>
        <span className="checkbox" />
        {label}
      </label>
    </S.ItemWrapper>
  );
}

export default CheckBox;
